import { connect } from 'react-redux';
import {
  getIsHotelOnly,
  getIsMobile,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import {
  isLastReview,
  getHasReviewsSection,
  getIsNewVariant,
} from 'src/store/reviews/selectors';
import { isRating } from 'src/store/hotelRating/selectors';

import {
  getHotelIsExpertReviewExists,
  hasFacts,
} from 'src/routes/Hotel/store/hotel';

import { hasExtraItems } from '../../store/selectors/extraitems';
import { getHasAboutHotel } from '../../store/selectors/common';
import { HotelInfoContainer } from './HotelInfo';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  hasRating: isRating(state),
  isLastReview: isLastReview(state),
  hasFacts: hasFacts(state),
  hasExtraItems: hasExtraItems(state),
  hasReviews: getHasReviewsSection(state),
  hasAboutHotel: getHasAboutHotel(state),
  isHotelOnly: getIsHotelOnly(state),
  isNewReviewsVariant: getIsNewVariant(state),
  isExpertReviewExists: getHotelIsExpertReviewExists(state),
  isWhiteLabel: getIsWhitelabel(state),
});

export default connect(mapStateToProps)(HotelInfoContainer);
